import React, { Component } from "react";

/**
 * @typedef {object} BaseComponentProps
 * @property {boolean} expanded
 * @property {Function} preview
 * @property {boolean} headerClickable
 * @property {React.MouseEventHandler} onToggle
 */

/**
 * @typedef {React.ComponentType<BaseComponentProps>} BaseComponent
 */

/**
 * @callback EnhanceDropDownHOC
 * @param {BaseComponent} BaseComponent
 * @returns {React.ComponentClass}
 */

/**
 * @callback EnhanceDropDownCallback
 * @returns {EnhanceDropDownHOC}
 */

/** @type {EnhanceDropDownCallback} */
const EnhanceDropDown = () => (BaseComponent) => {
  class DropDown extends Component {
    constructor(props) {
      super(props);
      this.toggle = this.toggle.bind(this);

      if (typeof props.expanded === "undefined") {
        this.state = {
          expanded: props.expandedInitially,
        };
      }
    }

    toggle(event) {
      if (event?.currentTarget && !event.currentTarget.contains(event.target)) {
        // This can happen when a modal is opened.
        // Even though the element is outside of the div element
        // React (or whatever mechanisms in the DOM) seems to hijack
        // the click and link it to the currentTarget.
        // If there is no event.currentTarget, it's likely because we're coming in
        // too late, and the original element already disappeared. This means that
        // it's safe to consider that the event was intended to remove this dropdown.
        return;
      }
      event?.stopPropagation();
      event?.preventDefault();

      if (this.state) {
        this.setState((state) => ({
          expanded: !state.expanded,
        }));
      } else {
        if (this.props.onToggle) {
          this.props.onToggle(!this.props.expanded);
        } else {
          console.warn(
            "If the prop `expanded` is passed to an DropDown, you should use a onToggle prop to listen for updates"
          );
        }
      }
    }

    render() {
      const isExpanded = this.state ? this.state.expanded : this.props.expanded;
      return (
        <BaseComponent
          {...this.props}
          expanded={isExpanded}
          preview={this.props.preview}
          onToggle={this.toggle}
          headerClickable={this.props.headerClickable}
        />
      );
    }
  }

  return DropDown;
};

export default EnhanceDropDown;
